<template>
  <div class="main">
    <div class="container">
      <div class="select">
        <div class="demo-input-suffix">
          国家:
          <el-select
            collapse-tags
            clearable
            size="mini"
            @change="countrysChange"
            v-model="countrys"
            multiple
          >
            <el-option v-for="(item, index) in countryList" :key="item" :value="item" :label="item"></el-option>
          </el-select>
          <!-- <el-cascader
            :options="countryList"
            :props="{ value: 'id', label: '',multiple: true}"
            collapse-tags
            clearable
            size="mini"
            @change="countrysChange"
          ></el-cascader>-->
        </div>
        <div class="demo-input-suffix" style="margin-left:10px">
          店铺名:
          <el-cascader
            v-model="sids"
            :options="sidsList"
            :props="{ value: 'id', label: 'name',multiple: true}"
            collapse-tags
            clearable
            size="mini"
            @change="sidsChange"
          ></el-cascader>
        </div>
        <div class="demo-input-suffix" style="margin-left:10px">
          状态:
          <el-select
            class="searchInput searchInput2 searchInput3"
            size="mini"
            v-model="isship"
            style="width:140px"
            placeholder="请选择"
            @change="shipChange"
          >
            <el-option v-for="item in isSends" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="demo-input-suffix trouInput" style="margin-left:10px">
          问题件:
          <el-cascader
            size="mini"
            v-model="trous"
            :options="isNormals"
            :props="{ value: 'id', label: 'name',multiple: true}"
            collapse-tags
            @change="trouChange"
            class="trousItem"
            clearable
          ></el-cascader>
        </div>
      </div>
      <div class="search">
        <span>
          <!-- <el-button size="mini" type="primary" @click="orderSync" v-if="false">同步订单</el-button> -->
          <el-button type="primary" size="mini" @click="exportExcel">导出订单</el-button>
          <el-button
            class="searchBtn"
            size="mini"
            type="primary"
            @click="unifyShip"
            :loading="unifyShipBtn"
          >一键发货</el-button>
          <el-button
            class="searchBtn"
            size="mini"
            type="primary"
            @click="backOrder"
            :loading="backOrderBtn"
          >回传运单</el-button>
          <el-button class="searchBtn" size="mini" type="primary" @click="editTrou()">批量操作问题件</el-button>
        </span>
        <div>
          <el-input
            class="searchInput searchInput2"
            size="mini"
            v-model="like"
            placeholder="请输入"
            @change="clickEnter"
          ></el-input>
          <el-button size="mini" type="primary" @click="queryOrder()">查询</el-button>
        </div>
      </div>
      <el-alert type="info">
        <span style="margin-right:30px;">
          共计
          <span style="font-weight:600;color:red;font-size:16px;">{{orderResult.total}}</span>个订单
        </span>
        <span style="margin-right:30px;">
          店铺数量：
          <span
            style="font-weight:600;font-size:16px;"
          >{{ sids.length?sids.length:sidsList.length }}</span>个
        </span>
        <span style="margin-right:30px;">
          待确认订单：
          <span style="font-weight:600;font-size:16px;">{{orderResult.waitnum}}</span>个
        </span>
        <span style="margin-right:30px;">
          已发货订单：
          <span style="font-weight:600;font-size:16px;">{{orderResult.finishnum}}</span>个
        </span>
        <span>
          未发货订单：
          <span style="font-weight:600;font-size:16px;">{{orderResult.noshipnum}}</span>个
        </span>
      </el-alert>
      <div class="BigContent" v-if="orderResult.page.length">
        <div class="itemNav">
          <span>
            <el-checkbox v-model="allChecked" @change="allChenkedChange"></el-checkbox>
          </span>
          <span>序号</span>
          <span>订单号</span>
          <span>自定义单号</span>
          <span>店铺</span>
          <span>订单金额</span>
          <span>运费</span>
          <span>付款</span>
          <span>状态</span>
          <span>运单号</span>
          <span>问题件</span>
          <span>创建时间</span>
        </div>
        <div
          class="item"
          v-for="(item,index) in orderResult.page"
          :key="item.id"
          @click="enterOrderDetails(item.id)"
        >
          <span @click.stop>
            <el-checkbox v-model="item.isFlag" @change="(e)=>singleChecked(e,item.id)"></el-checkbox>
          </span>
          <span @click.stop>{{ index+1 }}</span>
          <span @click.stop>{{ item.orderno }}</span>
          <span @click.stop>{{ item.diyorderno}}</span>
          <span>{{ item.shopname }}</span>
          <span>{{ item.price }}</span>
          <span>{{ item.shipprice }}</span>
          <span>
            <is-flag :flag="item.ispay" :title="['已付款','未付款']"></is-flag>
          </span>
          <span class="flowContent">
            <el-button
              :class="['flow',item.flow==='未发货'?'noship':'',item.flow==='待确认'?'isConfirm':'']"
              size="mini"
              slot="reference"
            >{{ item.flow }}</el-button>
          </span>
          <span @click.stop>
              <a :href="item.trackingno1" v-if="item.trackingno" target="_blank">{{ item.trackingno}}</a>
              <font v-else>-</font>
          </span>
          <span @click.stop="editTrou(item.id)">
            <span :class="['trouStatus',item.trouble!='正常'?'trouStatus2':'']"></span>
            {{ item.trouble }}
          </span>
          <span>{{ item.time }}</span>
        </div>
        <!-- 分页 -->
        <div class="pag">
          <span>
            共
            <span style="font-weight:600;color:red;font-size:16px;">{{ orderResult.total }}</span>条
          </span>
          <el-pagination
            background
            :page-count="orderResult.pnum"
            :current-page.sync="currentPage"
            :page-sizes="[ 100, 300,500,1000]"
            @size-change="sizeChange"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="pageChange"
          ></el-pagination>
        </div>
      </div>
      <div class="emptyData" v-else>暂无数据</div>
    </div>
    <!-- 修改问题件 -->
    <el-dialog title="修改问题件" :visible.sync="dialogFormVisible" width="500px">
      <div class="demo-input-suffix">
        问题件:
        <!-- <el-select
          class="searchInput searchInput2"
          size="mini" :props="{ value: 'id', label: 'name',multiple: true}"
            collapse-tags
          v-model="editisNormal"
          placeholder="请选择"
        >
          <el-option v-for="item in isNormals2" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>-->
        <el-cascader
          size="mini"
          v-model="editisNormal"
          :options="isNormals2"
          :props="{ value: 'id', label: 'name'}"
          collapse-tags
          @change="trouChange"
          class="trousItem"
          clearable
        ></el-cascader>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="confirmTrou">确 定</el-button>
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 一键发货选择发货物流 -->
    <el-dialog title="选择发货渠道" :visible.sync="dialogFormVisible2" width="500px">
      <div class="demo-input-suffix">
        发货渠道:
        <el-select
          class="searchInput searchInput2"
          size="mini"
          v-model="logistics"
          placeholder="请选择"
          value-key="code"
        >
          <el-option
            v-for="item in logisticsList"
            :key="item.code"
            :label="item.name"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="confirmLogistics">确 定</el-button>
        <el-button size="small" @click="dialogFormVisible2 = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import isFlag from "../../components/isFlag";
import {
  GetOrder,
  ShopifyOrder,
  GetShopDropList,
  GetOrderCountry,
  GetTrouOrderType,
  GetOrderFlowDrop,
  optorders,
  GetCurCompanyAttachTransChannel
} from "@/utils/api";
import {
  syncOrder,
  trouordertype,
  getOrderData,
  getUnifyShip,
  backtracking,
  optorder,
  getShopDrop,
  orderflowdrop,
  ordercountry
} from "../../service";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      dialogFormVisible: false,
      dialogFormVisible2: false, //一键发货弹出层
      input: "",
      allChecked: false,
      currentPage: 1, //点击查询，将分页重置为第一页
      orderno: "", //订单号
      diyorderno: "", //自定义单号
      sidsList: [], //店铺下拉列表
      sids: [], //店铺名选中id数组
      isship: null, //选中的状态
      trous: [], //问题件
      like: "", //模糊查询
      arrid: [], //获取选中订单的id数组
      arrid2: [], //选中订单的id数组(一键发货过滤掉已发货)
      editisNormal: "", //问题件修改
      pageNum: 1, //分页的当前页数，
      orderflowList: [], //订单状态进度
      size: 100, //每页显示条数，默认显示100条每页
      unifyShipBtn: false, //一键发货按钮显示加载中
      backOrderBtn: false, //回传订单按钮显示加载中
      value: "",
      countryList: [], //国家下拉列表数据
      countrys: [], //国家选中数据
      isSends: [], //状态下拉列表数据
      isSend: "", //状态下拉列表选中
      isNormals: [
        {
          id: 1,
          name: "正常"
        },
        {
          // id: 0,
          name: "非正常",
          children: []
        }
      ], //获取问题件数据
      isNormals2: [
        {
          id: 1,
          name: "正常"
        },
        {
          // id: 0,
          name: "非正常",
          children: []
        }
      ],
      isNormal: null,
      orderResult: { page: [] }, //订单列表数据
      editTrouid: null,
      props: { multiple: true },
      logisticsList: [
        //物流列表
        {
          code: "SZGHXB",
          name: "深圳挂号小包"
        },
        {
          code: "GZEUB",
          name: "广州E邮宝"
        },
        {
          code: "ZOTLGHXB",
          name: "中欧铁路挂号小包"
        },
        {
          code: "HLGHXB",
          name: "荷兰邮政挂号小包"
        }
      ],
      logistics: "" //一键发货物流列表选中
    };
  },
  created() {
    // 判断是否从sku页的去发货跳转过来
    if (this.$route.query.sku) {
      this.isship = 0;
      this.trous = [[1]];
      this.like = this.$route.query.sku;
    }
    this.isFirstEnter = true;
    this.getorderflowdrop();
    this.getordercountry();
    this.getOrder();
    this.getShopDropData();
    this.getCurCompanyAttachTransChannel();
  },
  watch: {
    $route(to, from) {
      // 判断是否从sku页的去发货跳转过来
      if (to.query.sku) {
        this.isship = 0;
        this.trous = [[1]];
        this.like = to.query.sku;
        this.countrys = [];
        this.sids = [];
        this.getOrder();
      }
    }
  },
  methods: {
    ...mapMutations(["setOrderDetailParams"]),
    enterOrderDetails(id) {
      this.$router.push({
        path: "/orderDetail",
        query: {
          id
        }
      });
    },
    // 订单同步
    orderSync() {
      this.$confirm(
        "更新订单列表您确定需要更新目前的订单列表吗？由于更新是网络请求操作，耗时较长，操作后，需要间隔五分钟后再查看状态,点击确定开始更新订单列表",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$message({
            message: "已执行同步操作,请一分钟后查看数据...",
            type: "success"
          });
          syncOrder().then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: "同步订单成功",
                type: "success"
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消同步订单"
          });
        });
    },
    //获取当前公司相关的货运渠道
    getCurCompanyAttachTransChannel(){
      GetCurCompanyAttachTransChannel({
        companyId:sessionStorage.getItem("companyId")
      }).then(res=>{
        if(res){
          this.logisticsList = [];
          res.transConfigSdkWithCompanies.forEach(v=>{
            this.logisticsList.push({
              code:v.channelCode,
              name:v.channelName,
              sdkCode:v.sdkCode
            })
          })
        }
      })
    },


    // 获取状态下拉列表数据
    getorderflowdrop() {
      //获取状态
      GetOrderFlowDrop().then(res => {
        if (res) {
          this.isSends = res;
        }
      });
      //获取问题件
      GetTrouOrderType().then(res => {
        if (res) {
          this.isNormals[1].children = res;
          this.isNormals[1].children = this.isNormals[1].children.filter(
            item => {
              return item && item.name != "正常";
            }
          );
          this.isNormals2[1].children = res;
        }
      });
    },
    // 获取国家下拉列表数据
    getordercountry() {
      GetOrderCountry().then(res => {
        if (res) {
          this.countryList = res;
        }
      });
    },
    // 获取订单列表数据
    getOrder(p = 1) {
      let params = {
        p,
        sids: [],
        like: this.like,
        flow: this.isship,
        trous: [],
        countrys: this.countrys,
        size: this.size
      };
      let arr2 = [];
      this.trous.map((el, i) => {
        el.map((itm, idx) => {
          if (itm != undefined) {
            arr2.push(itm);
          }
        });
      });
      params.trous = arr2;
      this.sids.map(el => {
        params.sids.push(el[0]);
      });
      if (params.flow === "") {
        params.flow = null;
      }
      this.setOrderDetailParams(params);
      GetOrder(params).then(res => {
        if (res) {
          this.orderResult = res;
          this.orderResult.page.map((item, i) => {
            if(item.trackingno){
              item.trackingno1 =  "https://t.17track.net/en#nums=" + item.trackingno
            }
            item.isFlag = false;
          });
          this.orderResult.page.map((item, i) => {
            this.arrid.map(el => {
              if (item.id === el) {
                item.isFlag = true;
              }
            });
          });
          this.singleChangeAll();
        }
      });
    },
    //查询订单
    queryOrder() {
      this.arrid = [];
      this.arrid2 = [];
      this.getOrder();
      this.currentPage = 1; //点击查询，将分页重置为第一页
    },
    // 获取店铺下拉列表
    getShopDropData() {
      GetShopDropList().then(res => {
        if (res) {
          this.sidsList = res;
        }
      });
    },
    // 打开修改问题件
    editTrou(id) {
      if (id) {
        this.editTrouid = id;
      } else {
        var arr = [];
        this.orderResult.page.forEach(item => {
          if (item.isFlag) {
            arr.push(item.id);
          }
        });

        if (arr.length == 0) {
          this.$message.error("请至少选择一条数据进行操作");
          return;
        }

        this.editTrouid = arr.join(",");
      }

      console.log(this.editTrouid);
      this.dialogFormVisible = true;
      this.editisNormal = "";
    },
    // 确定修改问题件
    confirmTrou() {
      var editisNormal = this.editisNormal.filter(item => item);
      if (this.editTrouid.toString().indexOf(",") > -1) {
        let params = {
          ids: this.editTrouid,
          opt: 3,
          trouid: editisNormal.toString()
        };
        optorders(params).then(res => {
             this.dialogFormVisible = false;
            this.$message({
              showClose: true,
              message: "修改问题件成功",
              type: "success",
              duration: 1000,
              onClose: () => {
                this.getOrder(this.pageNum);
              }
            });
        });
      } else {
        let params = {
          id: Number(this.editTrouid),
          opt: 3,
          trouid: editisNormal
        };
        optorder(params).then(res => {
          if (res.data.code === 0) {
            this.dialogFormVisible = false;
            this.$message({
              showClose: true,
              message: "修改问题件成功",
              type: "success",
              duration: 1000,
              onClose: () => {
                this.getOrder(this.pageNum);
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    // 店铺下拉多选发生改变
    sidsChange() {
      this.arrid = [];
      this.arrid2 = [];
      this.queryOrder();
    },
    // 国家下拉多选发生改变
    countrysChange() {
      this.arrid = [];
      this.arrid2 = [];
      this.queryOrder();
    },
    // 发货选中发生改变
    shipChange(e) {
      this.arrid = [];
      this.arrid2 = [];
      this.isship = e;
      this.queryOrder();
    },
    // 问题件选中发生改变
    trouChange(e) {
      this.arrid = [];
      this.arrid2 = [];
      // this.trous = arr;
      this.queryOrder();
    },
    // 分页
    pageChange(p) {
      this.allChecked = false;
      this.pageNum = p;
      this.getOrder(p);
    },
    // 分页的每页条数发生改变
    sizeChange(val) {
      this.size = val;
      this.getOrder();
    },
    // 点击改变单选
    singleChecked(e, id) {
      let arr = JSON.parse(JSON.stringify(this.orderResult.page));
      arr.map((item, i) => {
        if (item.id === id) {
          this.$set(item, "isFlag", e);
        }
      });
      // 如果选中，将id添加到arrid数组中，
      if (e) {
        if (this.arrid.indexOf(id) === -1) {
          this.arrid.push(id);
        }
        arr.map((item, i) => {
          if (item.id === id && item.flow === "未发货") {
            if (this.arrid2.indexOf(id) === -1) {
              this.arrid2.push(id);
            }
          }
        });
      } else {
        this.arrid.splice(this.arrid.indexOf(id), 1);
        this.arrid2.splice(this.arrid2.indexOf(id), 1);
      }
      this.orderResult.page = JSON.parse(JSON.stringify(arr));
      this.singleChangeAll(e);
    },
    // 点击全选改变单选
    allChenkedChange(e) {
      let arr = JSON.parse(JSON.stringify(this.orderResult.page));
      arr.map((item, i) => {
        arr[i].isFlag = e;
      });
      this.orderResult.page = JSON.parse(JSON.stringify(arr));
      // 如果选中，将所有的id添加到arrid数组中，
      if (e) {
        let arr = JSON.parse(JSON.stringify(this.orderResult.page));
        arr.map((el, i) => {
          if (this.arrid.indexOf(el.id) === -1) {
            this.arrid.push(el.id);
          }
          if (el.flow === "未发货") {
            if (this.arrid2.indexOf(el.id) === -1) {
              this.arrid2.push(el.id);
            }
          }
        });
      } else {
        arr.map((el, i) => {
          this.arrid.splice(this.arrid.indexOf(el.id), 1);
          this.arrid2.splice(this.arrid2.indexOf(el.id), 1);
        });
      }
    },
    // 单选改变全选
    singleChangeAll() {
      let arr = JSON.parse(JSON.stringify(this.orderResult.page));
      let flag = false;
      arr.map((el, i) => {
        if (el.isFlag === false) {
          flag = true;
        }
      });
      if (flag === false) {
        this.allChecked = true;
      } else {
        this.allChecked = false;
      }
    },
    // 导出excel
    exportExcel() {
      this.$confirm("是否导出订单列表?", "导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          require.ensure([], () => {
            const {
              export_json_to_excel
            } = require("../../vendor/Export2Excel");
            // 头部
            const tHeader = [
              "订单号",
              "自定义单号",
              "店铺",
              "订单金额",
              "运费",
              "付款",
              "状态",
              "运单号",
              "问题件",
              "创建时间"
            ];
            //对应的下面数组list的每个值的键,例如list = [{name:'胡歌',sex:'男',address:'上海'}]
            const filterVal = [
              "orderno", //订单号
              "diyorderno", //自定义单号
              "shopname", //店铺
              "price", //订单金额
              "shipprice", //运费
              "ispay", //付款
              "flow", //状态
              "trackingno", //运单号
              "trouble", //问题件
              "time" //创建时间
            ];
            let arr = JSON.parse(JSON.stringify(this.orderResult.page));
            arr.map((el, i) => {
              if (el.ispay === 1) {
                el.ispay = "已付款";
              } else {
                el.ispay = "未付款";
              }
            });
            const list = arr;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, "订单列表");
          });
          this.$message({
            type: "success",
            message: "导出成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 导出excel
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 打开一键发货
    unifyShip() {
      this.dialogFormVisible2 = true;
    },
    // 确认一键发货
    confirmLogistics() {
      this.dialogFormVisible2 = false;
      let params = {
        ids: this.arrid2, //选中id的数组
        select: 0 //0-自定义arrid2
      };
      this.sids.map(el => {
        params.sids.push(el[0]);
      });
      let params2 = {
        channelcode: this.logistics.code,
        orderfileter: params,
        sdkCode:this.logistics.sdkCode
      };

      this.unifyShipBtn = true;
      if (params.ids.length === 0) {
        this.$message({
          message: "请至少选择一个未发货订单",
          type: "warning"
        });
        this.unifyShipBtn = false;
      } else {
        getUnifyShip(params2).then(res => {
          this.unifyShipBtn = false;
          if (res.data.code === 0) {
            this.arrid = []; //操作成功后清除选中的id数组
            this.arrid2 = [];
            this.$message({
              message: "一键发货成功",
              type: "success",
              onClose: () => {
                this.getOrder(this.pageNum);
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    // 回传运单
    backOrder() {
      this.$confirm("您将要进行回传运单操作, 是否继续?", "回传运单", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            ids: this.arrid, //选中id的数组
            select: 0 //0-自定义arrid
          };
          this.backOrderBtn = true;
          backtracking(params).then(res => {
            this.backOrderBtn = false;
            if (res.data.code === 0) {
              this.arrid = []; //操作成功后清除选中的id数组
              this.arrid2 = [];
              this.$message({
                message: "回传订单成功",
                type: "success",
                onClose: () => {
                  this.getOrder(this.pageNum);
                }
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 点击回车触发查询
    clickEnter() {
      this.getOrder();
    }
  },
  mounted() {},
  components: {
    isFlag
  }
};
</script>

<style lang="less" scoped>
.main {
  background-color: #fff;
  border: 1px solid rgba(235, 237, 248, 1);
}
.container {
  width: 100%;
  padding: 0 20px;
  padding-top: 20px;
  border: none;
  box-sizing: border-box;
  .search {
    margin-left: auto;
    justify-content: space-between;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    > span {
      > span {
        color: #0077ff;
        display: inline-block;
        text-align: center;
        margin-right: 12px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    > div {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-direction: row;
    }
    .searchInput {
      width: 180px;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;
      border-radius: 0;
      margin-right: 6px;
    }
    .searchInput2 {
      // width: 120px;
    }

    .searchBtn2 {
      height: 28px;
      border-radius: 0;
    }
    .searchBtn {
      margin-left: 6px;
    }
    .searchContent {
      border: 1px solid rgba(221, 224, 227, 1);
      height: 26px;
      margin-right: 0px;
    }
  }
  .total {
    width: 121px;
    height: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 12px;
    margin: 10px 0;
  }
  .itemNav,
  .item {
    padding-left: 18px;
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
    }
    span:nth-child(1) {
      width: 20px;
      display: inline-block;
      margin-right: 0;
      height: 48px;
      line-height: 48px;
    }
    span:nth-child(2) {
      display: inline-block;
      text-align: center;
      width: 4%;
    }
    span:nth-child(3) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
    span:nth-child(4) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
    span:nth-child(5) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
    span:nth-child(6) {
      display: inline-block;
      text-align: center;
      width: 7%;
    }
    span:nth-child(7) {
      display: inline-block;
      text-align: center;
      width: 7%;
    }
    span:nth-child(8) {
      display: inline-block;
      text-align: center;
      width: 8%;
    }
    span:nth-child(9) {
      display: inline-block;
      text-align: center;
      width: 100px;
    }
    span:nth-child(10) {
      display: inline-block;
      text-align: center;
      width: 12%;
    }

    span:nth-child(11) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
    span:nth-child(12) {
      display: inline-block;
      text-align: center;
      width: 10%;
    }
  }
  .itemNav {
    margin-bottom: 10px;
  }
  .item {
    background: rgba(246, 249, 252, 1);
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    height: 48px;
    &:hover {
      cursor: pointer;
      background-color: #eee;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    span:nth-child(6) {
      color: #ffa000;
    }
    span:nth-child(8) {
      color: #333333;
    }
  }
  .pag {
    margin: 22px 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 8px;
    }
  }
}
.isFlag {
  width: 59px;
  height: 24px;
  background: rgba(223, 227, 232, 1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding: 0 13px;
  font-size: 12px;
  > span:first-child {
    width: 0 !important;
    box-sizing: border-box;
    border: 6px solid #999;
    display: inline-block;
    border-radius: 50%;
  }
  > p {
    display: inline-block;
    height: 14px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 14px;
    margin-left: 10px;
  }
}
.dialog-footer {
  text-align: center;
}
.demo-input-suffix {
  margin-right: 4px;
}
.emptyData {
  text-align: center;
  width: 100%;
  line-height: 200px;
  font-size: 20px;
  color: #e6e6e6;
}
.trouStatus {
  display: inline-block;
  width: 0px !important;
  height: 0px !important;
  border: 2.5px solid green;
  border-radius: 50%;
  margin: 0 4px;
  margin-right: 4px !important;
  margin-bottom: 2px;
}
.trouStatus2 {
  border: 2.5px solid red;
  margin-bottom: 2px;
}
.flowContent {
  display: flex !important;
  position: relative;
}
.flow {
  border: none;
  border-radius: 13px;
  background-color: #dfe3e8;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.noship {
  background-color: #ffe990;
}
.isConfirm {
  background-color: #fec48d;
}
.finishOk {
  color: #67c23a;
}
.finishNo {
  color: #909399;
}
.selectCheck {
  width: 10px;
  height: 10px;
  border: 1px solid #dcdfe6;
  transform: translate(0%, 90%);
}
.select {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;
}
.trouInput {
  margin-right: 0px !important;
}
.searchInput3 {
  width: 90px;
}
/deep/ .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 280px;
}
.trousItem {
  /deep/ input {
    width: 220px;
  }
}
</style>